import { Component, OnInit, HostBinding, Input } from '@angular/core';
import { DynamicForm } from '../../../interfaces/dynamic-form';
import { FormParams } from '../../../interfaces/form-params';

@Component({
  selector: 'bm-number-form',
  templateUrl: './number-form.component.html',
  styleUrls: ['./number-form.component.scss']
})
export class NumberFormComponent implements DynamicForm, OnInit {

  @HostBinding('class')
  @Input() className = '';

  @Input() params: FormParams;

  constructor() {}

  ngOnInit() {}

}
